import { render, staticRenderFns } from "./ValidationBadge.vue?vue&type=template&id=04af8114&"
import script from "./ValidationBadge.vue?vue&type=script&lang=ts&"
export * from "./ValidationBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports